import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { media } from '../ui-components';
import { randomNumberGenerator } from '../utils/random-number-generator';

const propTypes = {
  horizontal: PropTypes.string.isRequired,
  vertical: PropTypes.string.isRequired,
  pageType: PropTypes.string.isRequired,
  iconRngSeed: PropTypes.number
};

/**
 * Component that renders a random Icon based on page location and horizontal / vertical props
 *
 * @component Icon
 *
 * @param {object} props
 *
 * @prop {String} horizontal - must be 'left' or 'right'
 * @prop {String} vertical - must be 'top' or 'bottom'
 * @prop {String} pageType - 'services', 'industries', 'case-studies', etc
 * @prop {number} iconRngSeed - number to seed the random number generator
 */
const Icon = props => {
  const { horizontal = '', vertical = '', pageType = '', iconRngSeed = Date.now() } = props;
  const INDUSTRIES = [
    17, 19, 20, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 20, 41, 45, 46, 47, 48, 49, 50
  ];
  const SERVICES = [
    1, 2, 3, 4, 7, 8, 9, 10, 11, 12, 17, 19, 20, 21, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 50
  ];
  const ABOUT_US = [1, 3, 5, 6, 7, 8, 10, 11, 12, 17, 18, 20, 21, 22, 24, 25, 26, 37, 38, 40, 41, 42, 43, 44];

  const BOTTOM_ICONS = [8, 11, 12, 14, 15, 21, 23, 24, 28];
  const getIconMap = iconNumbers => {
    const getIcons = () => {
      const icons = require.context('../images/icons', false);
      let iconMap = {};
      icons.keys().map(icon => {
        iconMap[icon.replace('./', '').replace('.png', '')] = icons(icon);
      });

      return iconMap;
    };

    const icons = getIcons();
    const filteredIconMap = { left: [], right: [] };
    iconNumbers?.map(num => {
      if (vertical !== 'bottom') {
        icons[`icon-${num}-1`] && filteredIconMap['right'].push(icons[`icon-${num}-1`]);
        icons[`icon-${num}-2`] && filteredIconMap['right'].push(icons[`icon-${num}-2`]);

        icons[`icon-${num}-4`] && filteredIconMap['left'].push(icons[`icon-${num}-4`]);
        icons[`icon-${num}-5`] && filteredIconMap['left'].push(icons[`icon-${num}-5`]);
      }
      if (vertical !== 'bottom' || BOTTOM_ICONS.includes(num)) {
        icons[`icon-${num}-3`] && filteredIconMap['right'].push(icons[`icon-${num}-3`]);
        icons[`icon-${num}-6`] && filteredIconMap['left'].push(icons[`icon-${num}-6`]);
      }
    });

    return filteredIconMap;
  };

  const getRandomIcon = iconList => {
    let rng = randomNumberGenerator(iconRngSeed);
    return iconList[Math.floor(rng() * iconList.length)];
  };

  const getIconNumbers = () => {
    switch (pageType) {
      case 'industries':
        return INDUSTRIES;
      case 'services':
      case 'partnerships':
        return SERVICES;
      case 'about-us':
        return ABOUT_US;
      case 'careers':
        return ABOUT_US;
      default:
        break;
    }
  };

  const renderIcon = () => {
    const iconMap = getIconMap(getIconNumbers());
    const randomIcon = getRandomIcon(iconMap[horizontal]);

    return (
      randomIcon && <IconImg horizontal={horizontal} vertical={vertical} src={randomIcon['default']} alt={'icon'} />
    );
  };

  return renderIcon();
};

Icon.prototypes = propTypes;

export default Icon;

const IconImg = styled.img`
  position: absolute;
  z-index: 1;
  width: 400px;
  height: 160px;
  margin: 0;

  top: ${({ vertical }) => (vertical === 'top' ? '-92px' : 'default')};
  bottom: ${({ vertical }) => (vertical === 'bottom' ? '20px' : 'default')};
  right: ${({ horizontal }) => (horizontal === 'right' ? `-80px` : 'default')};
  left: ${({ horizontal }) => (horizontal === 'left' ? '-160px' : 'default')};

  @media screen and (max-width: ${media.largeTop}) {
    display: none;
  }
`;
